export const INVITATION_STATUS = {
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    PENDING: 'Pending',
};